import React, { useEffect, useState } from 'react'
import * as api from '../services/api'
import Loader from '../../components/Loader'
import { useDispatch } from 'react-redux'
import { login, user_data } from '../../store/authSlice'
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from "jwt-decode";


function ThaiD() {



    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getParameter()
    }, [])

    const getParameter = async() => {
        let state = new URLSearchParams(window.location.search).get('state')
        let refreshToken = new URLSearchParams(window.location.search).get('refresh_token')
        let accessToken = new URLSearchParams(window.location.search).get('access_token')

        if (['login'].includes(state)) {
            console.log(accessToken)
            console.log(refreshToken)
            // getUserData(accessToken, refreshToken)
            // const expire = jwtDecode(accessToken);
            // console.log("expire : ",expire);
            
            // dispatch(login({ "expire_datetime_in": expire }))

            localStorage.setItem('AccessToken', accessToken)
            localStorage.setItem('RefreshToken', refreshToken)
            await getProfile()

            navigate('/profile')
            // navigate('/healthNews')

        } else if (['register']) {
            navigate(`/register?register=thaiD&access_token=${accessToken}`)

        } else {
            navigate(`/`)
        }




        // FindPayloadThaiD(accessToken)
    }

    // const getUserData = async (token, refresh) => {
    //     const expire = jwtDecode(token);

    //     // dispatch(login({ "expire_datetime_in": expire }))
    //     localStorage.setItem('AccessToken', token)
    //     localStorage.setItem('RefreshToken', refresh)
    //     await getProfile()

    //     // navigate('/mentalHealthAssessment')
    //     // alert('ล็อกอินสำเร็จ')
    // }

    const getProfile = async () => {
        setLoading(true)
        let res = await api.profile()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200 || res['data']['status']) {
                dispatch(user_data(res['data']['data']))
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    // const FindPayloadThaiD = async (token) => {
    //     setLoading(true)
    //     let res = await api.FindPayloadThaiD(token)
    //     setLoading(false)
    //     if (res) {
    //         if (res['data']['code'] == 200) {
    //             console.log(res['data'])
    //         } else {
    //             alert(res['data'['message']])
    //         }
    //     } else {
    //         alert('ไม่ตอบสนอง')
    //     }
    // }

    return (
        <>
            <Loader loading={loading} />
        </>
    )
}

export default ThaiD
